import { render, staticRenderFns } from "./MultiSnackbarQV.vue?vue&type=template&id=5d4fb3c4&scoped=true&"
import script from "./MultiSnackbarQV.vue?vue&type=script&lang=js&"
export * from "./MultiSnackbarQV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fb3c4",
  null
  
)

export default component.exports